// extracted by mini-css-extract-plugin
module.exports = {"signUpPage":"styles_signUpPage__1PFMd","signUpContent":"styles_signUpContent__-qrEM","signUpForm":"styles_signUpForm__17_YC"};